/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How match_value is interpreted.
 */
export const UpdateRiskExclusionRequestBodyMatchType = {
  Exact: "exact",
  Regex: "regex",
  RuleId: "rule_id",
  Source: "source",
  EntityType: "entity_type",
} as const;
/**
 * How match_value is interpreted.
 */
export type UpdateRiskExclusionRequestBodyMatchType = ClosedEnum<
  typeof UpdateRiskExclusionRequestBodyMatchType
>;

export type UpdateRiskExclusionRequestBody = {
  /**
   * Whether the exclusion is active. Omit to leave unchanged.
   */
  enabled?: boolean | undefined;
  /**
   * The exclusion ID.
   */
  id: string;
  /**
   * How match_value is interpreted.
   */
  matchType: UpdateRiskExclusionRequestBodyMatchType;
  /**
   * The value matched against findings, interpreted per match_type.
   */
  matchValue: string;
  /**
   * Bind the exclusion to a single policy. Omit for a global (project-wide) exclusion.
   */
  riskPolicyId?: string | undefined;
  /**
   * Optional: only apply within this rule_id. Empty means any.
   */
  ruleIdFilter?: string | undefined;
  /**
   * Optional: only apply within this source. Empty means any.
   */
  sourceFilter?: string | undefined;
};

/** @internal */
export const UpdateRiskExclusionRequestBodyMatchType$outboundSchema:
  z.ZodMiniEnum<typeof UpdateRiskExclusionRequestBodyMatchType> = z.enum(
    UpdateRiskExclusionRequestBodyMatchType,
  );

/** @internal */
export type UpdateRiskExclusionRequestBody$Outbound = {
  enabled?: boolean | undefined;
  id: string;
  match_type: string;
  match_value: string;
  risk_policy_id?: string | undefined;
  rule_id_filter: string;
  source_filter: string;
};

/** @internal */
export const UpdateRiskExclusionRequestBody$outboundSchema: z.ZodMiniType<
  UpdateRiskExclusionRequestBody$Outbound,
  UpdateRiskExclusionRequestBody
> = z.pipe(
  z.object({
    enabled: z.optional(z.boolean()),
    id: z.string(),
    matchType: UpdateRiskExclusionRequestBodyMatchType$outboundSchema,
    matchValue: z.string(),
    riskPolicyId: z.optional(z.string()),
    ruleIdFilter: z._default(z.string(), ""),
    sourceFilter: z._default(z.string(), ""),
  }),
  z.transform((v) => {
    return remap$(v, {
      matchType: "match_type",
      matchValue: "match_value",
      riskPolicyId: "risk_policy_id",
      ruleIdFilter: "rule_id_filter",
      sourceFilter: "source_filter",
    });
  }),
);

export function updateRiskExclusionRequestBodyToJSON(
  updateRiskExclusionRequestBody: UpdateRiskExclusionRequestBody,
): string {
  return JSON.stringify(
    UpdateRiskExclusionRequestBody$outboundSchema.parse(
      updateRiskExclusionRequestBody,
    ),
  );
}
